module.exports = {
	"id": "CG",
	"name": "Congo, Republic of the",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.00329,
			"7": null,
			"8": null,
			"9": 0.001645,
			"10": 0.004935,
			"11": 0.05593,
			"12": null,
			"13": null,
			"14": 0.004935,
			"15": 0.00329,
			"16": null,
			"17": 0.00329,
			"18": null,
			"19": 0.00329,
			"20": null,
			"21": 0.00658,
			"22": 0.00987,
			"23": 0.001645,
			"24": null,
			"25": 0.018095,
			"26": 0.01645,
			"27": 0.024675,
			"28": 0.00329,
			"29": 0.004935,
			"30": 0.014805,
			"31": 0.04606,
			"32": 0.00658,
			"33": 0.02303,
			"34": 0.00987,
			"35": 0.00658,
			"36": 0.00987,
			"37": 0.021385,
			"38": 0.00329,
			"39": 0.00658,
			"40": 0.008225,
			"41": 0.00329,
			"42": 0.03619,
			"43": 0.060865,
			"44": 0.021385,
			"45": 0.13489,
			"46": 0.008225,
			"47": 0.03619,
			"48": 0.01974,
			"49": 0.18753,
			"50": 0.01645,
			"51": 0.080605,
			"52": 0.12173,
			"53": 4.26713,
			"54": 0.814275,
			"55": 0.00987,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.314195,
			"4": 0.02961,
			"5": 0.001645,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.00329,
			"10": 0.00658,
			"11": 0.018095,
			"12": 0.01974,
			"13": 0.037835,
			"14": 0.02303,
			"15": 0.00658,
			"16": 0.011515,
			"17": 0.00329,
			"18": 0.077315,
			"19": 0.01974,
			"20": 0.004935,
			"21": 0.001645,
			"22": 0.0329,
			"23": 0.004935,
			"24": 0.014805,
			"25": 0.067445,
			"26": 0.00987,
			"27": 0.008225,
			"28": 0.004935,
			"29": 0.01974,
			"30": 0.01645,
			"31": 0.024675,
			"32": 0.01316,
			"33": 0.00987,
			"34": 0.011515,
			"35": 0.04606,
			"36": 0.01316,
			"37": 0.02303,
			"38": 0.02303,
			"39": 0.03948,
			"40": 0.05922,
			"41": 0.01316,
			"42": 0.04935,
			"43": 0.19082,
			"44": 0.09541,
			"45": 0.070735,
			"46": 0.05922,
			"47": 0.85211,
			"48": 0.478695,
			"49": 2.900135,
			"50": 0.126665,
			"51": 0.03948,
			"52": null,
			"3.5": 0.00658,
			"3.6": 0.031255
		},
		"opera": {
			"9": null,
			"11": 0.03619,
			"12": 0.00987,
			"15": 0.00329,
			"16": 0.00329,
			"17": 0.00658,
			"18": 0.00658,
			"19": null,
			"20": 0.00329,
			"21": null,
			"22": 0.001645,
			"23": null,
			"24": null,
			"25": 0.00329,
			"26": null,
			"27": null,
			"28": 0.057575,
			"29": 0.001645,
			"30": 0.031255,
			"31": 0.001645,
			"32": 0.018095,
			"33": 0.001645,
			"34": 0.004935,
			"35": 0.00329,
			"36": 0.044415,
			"37": 0.044415,
			"38": 0.024675,
			"39": 0.05922,
			"40": 0.360255,
			"41": 0.044415,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.001645,
			"11.1": 0.004935,
			"11.5": 0.00329,
			"11.6": 0.011515,
			"12.1": 0.02961
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.008225,
			"6": 0.00987,
			"7": 0.01316,
			"8": 0.123375,
			"9": 0.12831,
			"10": 0.14476,
			"3.1": null,
			"3.2": null,
			"5.1": 0.057575,
			"6.1": 0.00987,
			"7.1": 0.01316,
			"9.1": 0.146405
		},
		"ios_saf": {
			"8": 0,
			"10": 0.95940925229,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0258549691923,
			"8.1-8.4": 0.0477659600333,
			"9.0-9.2": 0.0227874304746,
			"9.3": 0.34765438801
		},
		"android": {
			"3": 0,
			"4": 0.121186966408,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.015148370801,
			"4.1": 0.437138700258,
			"4.2-4.3": 1.09284675065,
			"4.4": 2.50597334109,
			"4.4.3-4.4.4": 2.5276138708
		},
		"ie": {
			"6": null,
			"7": 0.00671648471616,
			"8": 0.19309893559,
			"9": 0.117538482533,
			"10": 0.151120906114,
			"11": 1.06624194869,
			"5.5": null
		},
		"op_mob": {
			"0": 3.37602767834,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0937785466206
		},
		"edge": {
			"12": 0.09212,
			"13": 0.12502,
			"14": 0.06251
		},
		"ie_mob": {
			"10": 0.0823633802817,
			"11": 0.335336619718
		},
		"bb": {
			"7": 0.1858765,
			"10": null
		},
		"samsung": {
			"0": 1.771048
		},
		"and_uc": {
			"0": 13.082364
		},
		"op_mini": {
			"0": 45.484633775
		},
		"and_chr": {
			"0": 9.650549
		},
		"and_ff": {
			"0": 0.025062
		}
	},
	"total": 97.5579412576
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CG.json
 ** module id = 492
 ** module chunks = 0
 **/